import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2 } from "lucide-react";

const POLL_LIMIT = 8;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [orden, setOrden] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let cancelled = false;
    let attempts = 0;
    const tick = async () => {
      if (cancelled || attempts >= POLL_LIMIT) return;
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          if (data.orden_id) {
            const { data: o } = await api.get(`/ordenes/${data.orden_id}`);
            setOrden(o);
          }
          return;
        }
        setTimeout(tick, 2000);
      } catch {
        setTimeout(tick, 2000);
      }
    };
    tick();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#F9F9F8]">
      <Navbar />
      <div className="max-w-lg mx-auto px-6 py-16 text-center">
        {status === "polling" && (
          <>
            <Loader2 className="w-12 h-12 text-[#FF3366] animate-spin mx-auto" />
            <h1 className="font-display font-black text-3xl tracking-tighter mt-6">Confirmando pago…</h1>
            <p className="text-zinc-500 mt-2 text-sm">Un momento por favor.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto" strokeWidth={2} />
            <h1 className="font-display font-black text-4xl tracking-tighter mt-6">¡Pago exitoso!</h1>
            <p className="text-zinc-600 mt-3">Tu orden está siendo preparada por los locatarios.</p>
            {orden && (
              <div className="mt-6 bg-white border border-zinc-200 rounded-sm p-6 text-left">
                <div className="overline text-zinc-500">Código de entrega</div>
                <div data-testid="orden-token" className="font-display font-black text-4xl tracking-tighter mt-1">{orden.token_seguridad}</div>
                <p className="text-xs text-zinc-500 mt-2">Comparte este código con el repartidor al recibir tu pedido.</p>
                <div className="mt-4 text-sm">
                  <div className="flex justify-between text-zinc-600"><span>Total</span><span className="font-medium text-zinc-900">${orden.total.toFixed(2)}</span></div>
                </div>
              </div>
            )}
            <Link to="/cliente"><Button className="mt-6 rounded-sm bg-[#FF3366] hover:bg-[#E62958]" data-testid="view-orders">Ver mis pedidos</Button></Link>
          </>
        )}
        {status === "error" && (
          <>
            <h1 className="font-display font-black text-3xl">Sesión no encontrada</h1>
            <Link to="/"><Button className="mt-4">Volver</Button></Link>
          </>
        )}
      </div>
    </div>
  );
}
